/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"7\" height=\"7\"><path fill=\"#3899EC\" d=\"M5.923 1.838L1.077 6.685l-.762-.762 4.847-4.846H0V0h7v7H5.923V1.838z\"/></svg>\n";
//# sourceMappingURL=upper-arrow-right.svg.js.map